import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Company } from 'src/app/models/Company';
@Injectable({
    providedIn: 'root'
})
export class CompanyApi extends Api<Company> {
}
